import { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";

const ApproveTimeOffModal = ({ isApproveModalOpen, setIsApproveModalOpen, setModalIsOpen, timeOffId, token, refetchLeaves }) => {
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const handleConfirmApprove = async () => {
        if (!timeOffId) return;
        try {
            setIsSubmitLoading(true);
            await axios.get(`/api/time-off-request/approve/${timeOffId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Time Off Request approved successfully!", {
                position: "bottom-right",
                autoClose: 2000,
            });
            setModalIsOpen(false);
            handleCancelApprove();
            refetchLeaves();
        } catch (error) {
            console.error("Approval error:", error);
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelApprove = () => {
        setIsApproveModalOpen(false);
        document.body.classList.remove("ReactModal__Body--open");
    };

    return (
        <Modal
            className="center-modal"
            isOpen={isApproveModalOpen}
            onRequestClose={!isSubmitLoading ? handleCancelApprove : undefined}
            contentLabel="Confirm Delete"
            style={{
                content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    parent: document.querySelector(".admin-outer.time.tracker"),
                },
            }}
        >
            <div className="delete-modal-content">
                <h2>Confirm Approve</h2>
                <p>
                    Are you sure you want to Approve this Time Off Request?
                </p>
                {isSubmitLoading ?
                    (
                        <div className="outter-load-table">
                            <ThreeDots
                                height="28"
                                width="30"
                                radius="9"
                                color="#6479f9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                            />
                        </div>
                    ) : (
                        <div className="delete-modal-buttons">
                            <button className="buttons-approved" onClick={handleConfirmApprove} disabled={isSubmitLoading}>
                                Approve
                            </button>
                            <button onClick={handleCancelApprove} disabled={isSubmitLoading}>
                                Cancel
                            </button>
                        </div>
                    )}
            </div>
        </Modal>
    );
};

export default ApproveTimeOffModal;
